import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../../../../colors';

export const useStyles = makeStyles({
  container: {
    backgroundColor: colors.primary50,
    height: '100%',
    display: 'flex',
  },
  contentBox: {
    paddingLeft: '40px',
    paddingRight: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
    alignSelf: 'center',
  },
  disconnectedIcon: {
    width: '80px',
    height: '80px',
  },
  titleContainer: {
    padding: '0rem 4.5rem',
  },
  title: {
    color: colors.neutral900,
    textAlign: 'center',
    fontFamily: 'Manrope',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '130%',
    margin: 0,
  },
  subTitleContainer: {
    padding: '0rem 2rem',
    marginBottom: '1.5rem',
  },
  actionCard: {
    display: 'flex',
    padding: '16px 24px',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.neutral100}`,
    borderRadius: '8px',
    background: colors.white,
    boxShadow:
      '0px 10px 20px 0px rgba(0, 0, 0, 0.04), 0px 2px 6px 0px rgba(0, 0, 0, 0.04), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
  },
  permissionsContainer: {
    border: `2px solid ${colors.destructive500}`,
    borderRadius: '8px',
    background: colors.destructive50,
    padding: '16px 24px',
    alignSelf: 'stretch',
  },
  cardTitle: {
    alignSelf: 'stretch',
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    margin: 0,
  },
  cardDescription: {
    alignSelf: 'stretch',
    color: colors.neutral600,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
  },
  actionDetailsBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '4px',
    flex: '1 0 0',
  },
  actionBtn: {
    padding: 0,
    borderRadius: '4px',
    minWidth: '40px !important',
    width: '40px !important',
    height: '40px !important',
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
  callBtn: {
    border: `1px solid ${colors.indigo500}`,
    color: colors.indigo500,
    '& svg': {
      '& path': {
        fill: colors.indigo500,
      },
    },
    '&:hover': {
      backgroundColor: colors.indigo100,
    },
  },
  chatBtn: {
    border: `1px solid ${colors.orange500}`,
    color: colors.warning500,
    '& svg': {
      '& path': {
        fill: colors.warning500,
      },
    },

    '&:hover': {
      backgroundColor: colors.warning100,
    },
  },
  subTitle: {
    alignSelf: 'stretch',
    color: colors.neutral700,
    textAlign: 'center',
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
  },
  danger: {
    color: colors.destructive600,
  },
  timerText: {
    color: colors.secondary600,
  },
  textSection: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-end',
    gap: 24,
  },
  primaryBtn: {
    height: 48,
    padding: '10px 20px',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    fontFamily: 'Manrope',
    minWidth: 110,
    '&.Mui-disabled': {
      backgroundColor: colors.primary400,
      color: colors.white,
    },
  },
  outlineBtn: {
    height: 48,
    padding: '10px 20px',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    border: `1px solid ${colors.primary500}`,
    color: colors.primary500,
    minWidth: 110,
    '&:hover': {
      backgroundColor: colors.primary50,
    },
  },
  link: {
    color: colors.primary600,
    fontWeight: 700,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: colors.primary600,
    },
  },
  iconBtn: {
    width: 45,
    height: 45,
    minWidth: 45,
    borderRadius: '50%',
    backgroundColor: colors.white,
    border: `2px solid ${colors.neutral200}`,
    '& svg path': {
      color: colors.neutral900,
    },
    '&:hover': {
      backgroundColor: colors.white,
      border: `2px solid ${colors.neutral900}`,
    },
  },
  hangupBtn: {
    color: colors.white,
    width: 45,
    height: 45,
    minWidth: 45,
    borderRadius: '50%',
    backgroundColor: colors.destructive500,
    cursor: 'pointer',
    border: `2px solid ${colors.destructive500}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg path': {
      fill: colors.white,
    },
    '&:hover': {
      backgroundColor: colors.destructive600,
      border: `2px solid ${colors.destructive600}`,
    },
  },
});
